import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import WalletSettingsContainer from '../../../../../../../../../components/source-management/wallets/wallet-page/wallet-settings/WalletSettingsContainer';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: WalletSettingsContainer,
});
